module.exports = __webpack_public_path__ + "static/media/fastGamesPlayed_500000_1000000.ac778b08.png";